export default "__VITE_ASSET__b1Kk1iZp__"